import "./style.scss";

import { initialForWorkName, type WorkTone } from "../workTone";

type WorkBookStackProps = {
    name: string;
    titleCount: number;
    tone: WorkTone;
    avatarUrl?: string | null;
};

const STACK_MAX = 3;

const WorkBookStack = ({ name, titleCount, tone, avatarUrl }: WorkBookStackProps) => {
    const stackCount = Math.min(titleCount, STACK_MAX);
    const initial = initialForWorkName(name);

    return (
        <div className={`work-book-stack ${avatarUrl ? `work-book-stack--${tone}` : "work-book-stack--empty"}`}>
            {stackCount >= 3 && (
                <div className="work-book-stack__layer work-book-stack__layer--back" aria-hidden>
                    {avatarUrl ? <img className="work-book-stack__cover-image" src={avatarUrl} alt="" /> : initial}
                </div>
            )}
            {stackCount >= 2 && (
                <div className="work-book-stack__layer work-book-stack__layer--mid" aria-hidden>
                    {avatarUrl ? <img className="work-book-stack__cover-image" src={avatarUrl} alt="" /> : initial}
                </div>
            )}
            <div className="work-book-stack__cover">
                {avatarUrl ? <img className="work-book-stack__cover-image" src={avatarUrl} alt="" /> : initial}
            </div>
        </div>
    );
};

export default WorkBookStack;
